import axios from 'axios';

const API_URL = '/api/auth';

const authenticatedConfig = () => {
  const token = localStorage.getItem('token');
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export const getAllUsersActive = async () => {
  const response = await axios.get(`${API_URL}/active`, authenticatedConfig());
  return response.data;
};

export const getUser = async (userid) => {
  const response = await axios.get(`${API_URL}/user/${userid}`, authenticatedConfig());
  return response.data;
};

export const createUser = async (dados) => {
  const response = await axios.post(`${API_URL}/register`, dados);
  return response.data;
};

export const updateUser = async (id, dados) => {
  const response = await axios.put(`${API_URL}/user/${id}`, dados, authenticatedConfig());
  return response.data;
};

export const sendWhatsappTest = async (id) => {
  try {
    const response = await axios.post(`${API_URL}/user/${id}/whatsapp-test`, {}, authenticatedConfig());
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Não foi possível enviar a mensagem de teste');
  }
};

export const getCompleteConfluenceOpportunities = async () => {
  const response = await axios.get('/api/opportunities/complete', authenticatedConfig());
  return response.data;
};

export const getRealtimeAlerts = async (limit = 50) => {
  const response = await axios.get('/api/alerts', {
    ...authenticatedConfig(),
    params: { limit },
  });
  return response.data;
};

export const markRealtimeAlertRead = async (id) => {
  const response = await axios.patch(`/api/alerts/${id}/read`, {}, authenticatedConfig());
  return response.data;
};

export const markAllRealtimeAlertsRead = async () => {
  const response = await axios.post('/api/alerts/read-all', {}, authenticatedConfig());
  return response.data;
};

export const getAlertMonitorStatus = async () => {
  const response = await axios.get('/api/alerts/monitor-status', authenticatedConfig());
  return response.data;
};

export const getKairiGovernance = async () => {
  const response = await axios.get('/api/user/kairi-governance', authenticatedConfig());
  return response.data;
};

export const updateKairiGovernance = async (mode) => {
  const response = await axios.put('/api/user/kairi-governance', { mode }, authenticatedConfig());
  return response.data;
};

export const deleteUser = async (id) => {
  const response = await axios.delete(`${API_URL}/user/${id}/`);
  return response.data;
};

export const firstAccess = async (email, newPassword, token) => {
  const response = await axios.post(`${API_URL}/first-access`, {
    email,
    newPassword,
  }, token ? { headers: { Authorization: `Bearer ${token}` } } : {});
  return response.data;
};

export const requestPasswordReset = async (email) => {
  const response = await axios.post(`${API_URL}/forgot-password`, { email });
  return response.data;
};

export const resetPassword = async (token, newPassword) => {
  const response = await axios.post(`${API_URL}/reset-password`, {
    token,
    newPassword,
  });
  return response.data;
};

